import { render } from "./JustTransition.vue?vue&type=template&id=0bb69b59&ts=true"
import script from "./JustTransition.vue?vue&type=script&lang=ts"
export * from "./JustTransition.vue?vue&type=script&lang=ts"

import "./JustTransition.vue?vue&type=style&index=0&id=0bb69b59&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__